import React from 'react'
import { Icon } from 'semantic-ui-react'
import styles from '../styles'

// Drop shadow in semantic-ui has too many !importants, the seems simplest way to get rid of them
const XCancelButton = ({ onClick, ...rest }) => {
  return (
    <button style={styles.xButtonStyle} onClick={() => onClick()} rest={rest}>
      <Icon name='cancel' color='blue' />
    </button>
  )
}

export default XCancelButton
